import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import { DEVICES_IPTV } from "src/requests/tasks/constants";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
class StartHeaderInfoTask extends AbstractRequestTask {
    constructor(HKS = "") {
        super();
        this.HKS = HKS;
        this.getDeviceManufacturer = super.getParams().device_manufacturer.toLowerCase();
        this.validateDeviceIsIptv = DEVICES_IPTV.includes(this.getDeviceManufacturer);
        this.isIptv = DeviceStorage.getItem('isIptv') && DeviceStorage.getItem('isIptv') === 'true' ? true : false;
    }

    getHeaders() {
        return {};
    }

    getParams() {
        const params = super.getParams();
        const HKS = this.HKS || params.HKS;

        const paramsReturn = {
          HKS,
          authpn: params.authpn,
          authpt: params.authpt,
          device_type: params.device_type,
          device_category: params.device_category,
          device_id: params.device_id,
          device_model: params.device_model,
          device_manufacturer: params.device_manufacturer,
          device_so: params.device_so,
          device_name: params.device_name,
          format: params.format,
        };

        if(this.validateDeviceIsIptv && this.isIptv){
          delete paramsReturn.format;
          delete paramsReturn.HKS;
        };

        return paramsReturn
    }

    getUrl() {
        const url = this.validateDeviceIsIptv && this.isIptv
        ? `${Device.getDevice().getConfig().akamai_mfwk}/services/user/v1/startheaderinfo`
        : `${Device.getDevice().getConfig().akamai_mfwk}/services/user/startheaderinfo`;
        
        return url;
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default StartHeaderInfoTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/StartHeaderInfoTask.js